import { useGoogleLocation } from "@/modules/jobAds/client/hooks/useGoogleLocation"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { useWoosmapLocation } from "@/modules/locations/hooks/useWoosmapLocation"

type UseLocationFilter =
  | (() => ReturnType<typeof useGoogleLocation>)
  | ((apiKey: string) => ReturnType<typeof useWoosmapLocation>)

export const useLocationFilter = (): UseLocationFilter => {
  const { isJobAdsFoWoosmapMigrationEnabled } = usePageContext()

  return isJobAdsFoWoosmapMigrationEnabled ? useWoosmapLocation : useGoogleLocation
}
